import React from 'react'

const GeneralRules = () => {
  return (
    <div>GeneralRules</div>
  )
}

export default GeneralRules